<template>
  <gg-card v-if="isRequestsAvailable">
    <gg-card-header>
      My Data Requests

      <gg-btn class="float-right" :disabled="loading" @click="loadData">
        <v-icon>
          mdi-refresh
        </v-icon>
      </gg-btn>
    </gg-card-header>
    <gg-card-text>
      <transition name="fade">
        <v-data-table :headers="headers" :items="requests" :loading="loading">
          <template v-slot:item.actions="{ item }">
            <gg-btn :disabled="item.download_available === 0" @click="downloadRequest(item.id)">
              Download
            </gg-btn>
          </template>
        </v-data-table>
      </transition>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MyDataRequest',
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id',
        sortBy: 'id',
        sortDesc: true
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Created',
        value: 'created_at'
      },
      {
        text: 'Generated',
        value: 'generated_at'
      },
      {
        text: 'Downloaded',
        value: 'downloaded_at'
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'center'
      }
    ],
    loading: false
  }),
  mounted () {
    this.loadData()
  },
  computed: {
    ...mapGetters(['requests']),
    isRequestsAvailable () {
      return this.requests.length !== 0
    }
  },
  methods: {
    ...mapActions(['gdprDataRequests', 'gdprDataRequestsDownload', 'reportError']),
    async loadData () {
      try {
        this.loading = true
        await this.gdprDataRequests()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    async downloadRequest (id) {
      try {
        const { download } = await this.gdprDataRequestsDownload(id)

        this.handleDownload(download)

        await this.loadData()
      } catch (e) {
        this.reportError(e)
      }
    },
    handleDownload (data) {
      const a = document.createElement('a')
      a.href = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json'
      }))
      a.setAttribute('download', 'my_data.json')
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
